import { Button, Divider, Grid, IconButton, Typography } from '@mui/material'
import React, { useCallback, useContext, useMemo, useState } from 'react'
import FileUploader from '../../../components/FileUploader'
import dayjs from 'dayjs'
import { metodoPrograma } from '../../../components/api'
import PrimeTable from '../../../components/PrimeTable'
import { LuEye } from 'react-icons/lu'
import ModalDocumento from './ModalDocumento'
import { useModal } from '../../../components/Utils/UseModal'
import { PropostaContext } from '.'
import ModalEmissaoExame from './ModalEmissaoExame'

const Anexos = () => {
  const openModal = useModal(ModalDocumento)
  const openModalEmissaoExame = useModal(ModalEmissaoExame)

  const { dadosEdicao } = useContext(PropostaContext)

  const [refresh, setRefresh] = useState(true)

  const idAtendimento = useMemo(
    () => dadosEdicao?.idAtendimento,
    [dadosEdicao?.idAtendimento],
  )

  const salvaDocumento = async (v) => {
    const documento = v?.documento[0]

    const payload = {
      idDocumento: documento?.idDocumento,
      dsDocumento: documento?.fileName,
      idAtendimento,
    }

    await metodoPrograma('salvaDocumento', payload)

    setRefresh((v) => !v)
  }

  const abrirRequisicaoExame = async () => {
    await openModalEmissaoExame({ idAtendimento: dadosEdicao?.idAtendimento })
  }

  const abrirArquivo = async (linhaOriginal) => {
    await openModal({
      nmDocumento: linhaOriginal?.[1],
      token: linhaOriginal?.[4],
    })
  }

  const exclui = useCallback((linhaOriginal) => {
    metodoPrograma('deletaDocumento', {
      idAtendimento: linhaOriginal?.[2],
      idDocumento: linhaOriginal?.[0],
    }).then((res) => {
      if (res.status) {
        setRefresh((v) => !v)
      }
    })
  }, [])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} style={{ marginTop: 20 }}>
        <Typography variant="h5">Anexos</Typography>
        <Divider />
      </Grid>

      {dadosEdicao.tpSituacao === '0' && (
        <Grid item xs={12} style={{ marginTop: 20 }}>
          <FileUploader
            path="/proposta/"
            snPublico="N"
            onUploadComplete={salvaDocumento}
          />
        </Grid>
      )}
      {dadosEdicao.tpSituacao === '1' && (
        <Grid item xs={12} style={{ marginTop: 20 }}>
          <Button
            variant="contained"
            fullWidth
            color="primary"
            style={{ margin: '5px' }}
            onClick={abrirRequisicaoExame}
          >
            Requisitar Exames
          </Button>
        </Grid>
      )}

      <Grid item xs={12}>
        <PrimeTable
          codigo="CtrlProposta"
          action="listaDocumento"
          rows={10}
          parametros={{ idAtendimento }}
          head={['Arquivo', 'Título', 'Usuário', 'Data', 'Ações']}
          line={(item) => [
            item?.[1],
            item?.[7],
            item?.[3]?.[1],
            item?.[6] ? dayjs(item?.[6]).format('DD/MM/YYYY HH:mm') : '',
            '',
          ]}
          refresh={refresh}
          onDelete={
            dadosEdicao.tpSituacao === '0' ? { action: exclui } : undefined
          }
          collumnsDateHour={[4]}
          columnOptions={[
            {
              alias: 4,
              customJsx: ({ linhaOriginal }) => (
                <IconButton
                  onClick={() => abrirArquivo(linhaOriginal)}
                  size="small"
                >
                  <LuEye />
                </IconButton>
              ),
            },
          ]}
        />
      </Grid>
    </Grid>
  )
}

export default Anexos
